import { h, clear } from './dom.js';
import { mountTransportBar } from './transport-bar.js';
import { mountPatternBank } from './pattern-bank.js';
import { mountArrangementView } from './arrangement-view.js';
import { mountChannelRack } from './channel-rack.js';
import { mountMixerPanel } from './mixer-panel.js';
import { mountProjectBar } from './project-bar.js';

export function mountShell(ctx, root) {
    clear(root);

    const overlay = h('div.overlay', {}, [
        h('div.overlay-card', {}, [
            h('h2', {}, 'Music Maker'),
            h('p', {}, 'Click anywhere to start. Browsers require a user gesture before audio can play.'),
            h('button.btn.btn-primary', {
                onClick: () => ctx.start().catch(e => alert(e.message)),
            }, 'Start'),
        ]),
    ]);
    overlay.addEventListener('click', () => ctx.start().catch(e => alert(e.message)));

    const transportSlot = h('header.topbar');
    const projectSlot = h('div.projectbar');
    const patternSlot = h('section.lane.pattern-lane');
    const songSlot = h('section.lane.arrangement-lane');
    const rackSlot = h('section.lane.rack-lane');
    const mixerSlot = h('section.lane.mixer-lane');

    const layout = h('div.app', {}, [
        transportSlot,
        projectSlot,
        patternSlot,
        songSlot,
        rackSlot,
        mixerSlot,
        overlay,
    ]);
    root.appendChild(layout);

    // Components mount themselves once the audio engine is started so they
    // see the registered modules (channels, instruments, lanes).
    ctx.bus.on('app:started', () => {
        overlay.classList.add('hidden');
        mountTransportBar(ctx, transportSlot);
        mountProjectBar(ctx, projectSlot);
        mountPatternBank(ctx, patternSlot);
        mountArrangementView(ctx, songSlot);
        mountChannelRack(ctx, rackSlot);
        mountMixerPanel(ctx, mixerSlot);
    });
}
